import axios from 'axios'

const API_URL = import.meta.env.VITE_API_URL || ''

export const api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  withCredentials: true, // Send cookies with requests
  headers: {
    'Content-Type': 'application/json',
  },
})

// Interceptor for response errors (e.g., 401 -> refresh token)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    // If 401 and we haven't already tried to refresh
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      try {
        // Try to refresh token
        await api.post('/api/snagmatic/auth/refresh')
        // Retry original request
        return api(originalRequest)
      } catch (refreshError) {
        // Refresh failed - user needs to login again
        // The AuthContext will handle this via the /auth/me check
        return Promise.reject(refreshError)
      }
    }

    return Promise.reject(error)
  }
)

// API endpoints
export const authApi = {
  login: (email, password) => api.post('/api/snagmatic/auth/login', { email, password }),
  signup: (email, password, name) => api.post('/api/snagmatic/auth/signup', { email, password, name }),
  logout: () => api.post('/api/snagmatic/auth/logout'),
  refresh: () => api.post('/api/snagmatic/auth/refresh'),
  me: () => api.get('/api/snagmatic/auth/me'),
}

export const reportApi = {
  create: (data) => api.post('/api/snagmatic/reports', data),
  list: (filters) => api.get('/api/snagmatic/reports', { params: filters }),
  get: (id) => api.get(`/api/snagmatic/reports/${id}`),
  update: (id, data) => api.patch(`/api/snagmatic/reports/${id}`, data),
}

export const authorityApi = {
  list: () => api.get('/api/snagmatic/authorities'),
  create: (data) => api.post('/api/snagmatic/authorities', data),
  get: (id) => api.get(`/api/snagmatic/authorities/${id}`),
  update: (id, data) => api.patch(`/api/snagmatic/authorities/${id}`, data),
}

export default api
